
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const voucherService = {
     getCorporateVoucherList,
     corporateVoucherDetails,
    createVoucher,
    shareVouchers,
    updateVoucher,
    getVoucherOffline,
    getVoucherOfflineDetails,
    searchVoucherById,
    verifyOtp,
    sendVoucherOtp,
    voucherRedeemAction,
    getVoucherList,
    voucherDetails,
    getCorVoucherByDate,
    searchCorperateVoucher,
    searchVoucher,
    voucherByDate

    
 
};


async function  getVoucherOfflineDetails(id) {
    return  apiClient.get(`/accounts/voucher-offline-details/${id}`, authHeader());
}



async function  getCorporateVoucherList() {
    return  apiClient.get(`/accounts/get-cor-voucher-list`, authHeader());
}

function corporateVoucherDetails(id){
    return apiClient.get(`/accounts/get-cop-voucher-details/${id}`, authHeader())
   }


function getCorVoucherByDate(formData){
    return apiClient.post(`/accounts/get-cop-voucher-by-date`,formData,  authHeader())
   }


    async function  searchCorperateVoucher(searchText) {
           return  apiClient.get(`/accounts/cop-voucher-search?search=${searchText}`, authHeader());
       }

function updateVoucher(data){
    return apiClient.put(`/accounts/update-voucher`, data, authHeader())
 
   }
   function createVoucher(data){
    return apiClient.post(`/accounts/create-voucher`,data, authHeader())
   }



function voucherByDate(formData){
    return apiClient.post(`/accounts/voucher-by-date`,formData,  authHeader())
   }


    async function  searchVoucher(searchText) {
           return  apiClient.get(`/accounts/voucher-search?search=${searchText}`, authHeader());
       }



async function  getVoucherList() {
    return  apiClient.get(`/accounts/get-voucher-list`, authHeader());
}

function voucherDetails(id){
    return apiClient.get(`/accounts/get-voucher-details/${id}`, authHeader())
   }




function shareVouchers(data){
    return apiClient.post(`/accounts/share-vouchers`,data, authHeader())
 
   }


function getVoucherOffline(){
    return apiClient.get(`/accounts/voucher-offline`, authHeader())
 
   }


function  searchVoucherById(id){
    return apiClient.get(`/accounts/search-voucher-by-id/${id}`, authHeader())
   }
   
   
   function  verifyOtp(data){
       return apiClient.put(`/accounts/verify-voucher-otp`, data, authHeader())
    }
    
    
    function  sendVoucherOtp(id){
        return apiClient.get(`/accounts/send-voucher-otp/${id}`, authHeader())
       }

    function  voucherRedeemAction(data){
        return apiClient.post(`/accounts/voucher-redeem-action`, data, authHeader())
       }


